import React from 'react';
import { Button } from '@/components/ui/button';

const FinalCTA = () => {
  return (
    <section className="py-24 bg-cs-primary text-white overflow-hidden relative">
      {/* Abstract Background Shapes */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-cs-accent-yellow/10 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl"></div>
      
      <div className="container px-4 mx-auto text-center relative z-10">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
          Scale your team. Not your hiring effort.
        </h2>
        <p className="text-xl md:text-2xl opacity-90 mb-12 max-w-2xl mx-auto font-medium">
          Grab the Startup Support Plan now
        </p>
        
        <div className="flex items-center justify-center">
          <Button asChild size="lg" variant="outline" className="border-2 border-white/80 bg-white/5 backdrop-blur-sm text-white hover:bg-white/15 hover:border-white px-10 h-16 text-xl rounded-2xl transition-all font-semibold">
            <a href="https://share.hsforms.com/1hCH9XA96TFOoIblaesPhvgbpcum" target="_blank" rel="noopener noreferrer">
              Get a callback
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
